module.exports = __webpack_public_path__ + "static/media/1013933.b98991f4.jpg";